import type { ReactNode } from "react"
import React from "react"

import { Appointments } from "@/lib/appointments"
import { Authentication } from "@/lib/authentication"
import { Background } from "@/lib/background"
import { BookingSource } from "@/lib/booking_source"
import { BookingSearch } from "@/lib/bookingSearch"
import { Caches } from "@/lib/caches"
import { Caching } from "@/lib/caching"
import { Geolocation } from "@/lib/geolocation"
import { Loading } from "@/lib/loading"
import { Notices } from "@/lib/notices"
import { Routing } from "@/lib/routing"
import { Services } from "@/lib/services"

type Props = {
  children: ReactNode
}

type State = Record<string, never>

export class AppContext extends React.PureComponent<Props, State> {
  public render = () => {
    return (
      <Loading.Container>
        <Background.Container>
          <Routing.Container>
            <Notices.Container>
              <Authentication.Container>
                <BookingSource.Container>
                  <Geolocation.Container>
                    <Services.Container>
                      <Caching.Container buildStore={Caches.buildStore}>
                        <BookingSearch.Container>
                          <Appointments.Container>
                            <Loading.Screen>
                              {this.props.children}
                            </Loading.Screen>
                          </Appointments.Container>
                        </BookingSearch.Container>
                      </Caching.Container>
                    </Services.Container>
                  </Geolocation.Container>
                </BookingSource.Container>
              </Authentication.Container>
            </Notices.Container>
          </Routing.Container>
        </Background.Container>
      </Loading.Container>
    )
  }
}
